function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "101.7%",
  height: "117.8%",
  x: "-.8%",
  y: "-8.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#a)",
  opacity: 0.127,
  transform: "translate(-910 -41)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#1CA6FF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M999.39 85.58c-2.484 0-4.508 2.043-4.508 4.552 0 20.072-16.189 36.417-36.07 36.417-9.657 0-18.763-3.853-25.49-10.681l5.481-5.717c1.136-1.147.337-3.1-1.278-3.1l-17.481 1.272c-.994 0-1.811.806-1.811 1.828l.964 17.484c0 1.63 1.935 2.437 3.07 1.29l4.646-6.623c8.45 8.53 19.828 13.351 31.899 13.351 24.87 0 45.087-20.413 45.087-45.52 0-2.51-2.023-4.553-4.508-4.553zM922.742 90.132c0-20.072 16.189-36.417 36.07-36.417 9.603 0 18.727 3.89 25.473 10.7l-5.135 6.251c-1.136 1.147-.338 3.1 1.278 3.1h17.328c.994 0 1.81-.806 1.81-1.827l-.158-19.357c0-1.631-1.934-2.437-3.07-1.29l-5.663 6.689c-8.45-8.495-19.863-13.37-31.863-13.37-24.87 0-45.088 20.413-45.088 45.521 0 2.51 2.024 4.552 4.509 4.552 2.485 0 4.509-2.043 4.509-4.552z"
})));

const SvgIcBannerCloudSync = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 102,
    viewBox: "0 0 101 102",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBannerCloudSync, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-banner-cloud-sync.b4dce844.svg";
export { ForwardRef as ReactComponent };